'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _messageHeader = require('../message-header');

var _messageHeader2 = _interopRequireDefault(_messageHeader);

var _messageTime = require('../message-time');

var _messageTime2 = _interopRequireDefault(_messageTime);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _button = require('../../button');

var _button2 = _interopRequireDefault(_button);

var _iconPlay = require('../../icons/icon-play');

var _iconPlay2 = _interopRequireDefault(_iconPlay);

var _iconPause = require('../../icons/icon-pause');

var _iconPause2 = _interopRequireDefault(_iconPause);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  avatar: _propTypes2.default.string,
  createdAt: _propTypes2.default.string.isRequired,
  username: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['text', 'image', 'sticker', 'giphy', 'video', 'audio']),
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageHeaderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageTimeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  myMessage: _propTypes2.default.bool,
  compact: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  badge: _propTypes2.default.node,
  iconMenu: _propTypes2.default.node,
  audio: _propTypes2.default.shape({
    onPlay: _propTypes2.default.func.isRequired,
    onPause: _propTypes2.default.func.isRequired,
    isPlaying: _propTypes2.default.bool.isRequired,
    progress: _propTypes2.default.number.isRequired,
    time: _propTypes2.default.node.isRequired
  }).isRequired
};

var defaultProps = {
  avatar: '',
  type: 'audio',
  style: {},
  messageHeaderStyle: {},
  messageTimeStyle: {},
  fontSize: 'small',
  myMessage: false,
  compact: false,
  color: _colors2.default.theme,
  badge: null,
  iconMenu: null
};

var AudioMessage = function (_Component) {
  _inherits(AudioMessage, _Component);

  function AudioMessage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AudioMessage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AudioMessage.__proto__ || Object.getPrototypeOf(AudioMessage)).call.apply(_ref, [this].concat(args))), _this), _this.renderButton = function () {
      var _this$props = _this.props,
          myMessage = _this$props.myMessage,
          audio = _this$props.audio;


      if (audio.isPlaying) {
        return _react2.default.createElement(
          _button2.default,
          { style: _styles2.default.button, iconButton: true, onClick: audio.onPause },
          _react2.default.createElement(_iconPause2.default, { width: '18', height: '18', color: myMessage ? _colors2.default.white : _colors2.default.icons })
        );
      }

      return _react2.default.createElement(
        _button2.default,
        { style: _styles2.default.button, iconButton: true, onClick: audio.onPlay },
        _react2.default.createElement(_iconPlay2.default, { width: '18', height: '18', color: myMessage ? _colors2.default.white : _colors2.default.icons })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AudioMessage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          color = _props.color,
          myMessage = _props.myMessage,
          avatar = _props.avatar,
          compact = _props.compact,
          style = _props.style,
          fontSize = _props.fontSize,
          messageHeaderStyle = _props.messageHeaderStyle,
          createdAt = _props.createdAt,
          username = _props.username,
          type = _props.type,
          messageTimeStyle = _props.messageTimeStyle,
          badge = _props.badge,
          iconMenu = _props.iconMenu,
          audio = _props.audio;


      return _react2.default.createElement(
        'div',
        { style: _getStyles2.default.root(color, myMessage, avatar, compact, iconMenu, style) },
        _react2.default.createElement(_messageHeader2.default, {
          avatar: avatar,
          compact: compact,
          myMessage: myMessage,
          fontSize: fontSize,
          headerStyle: messageHeaderStyle,
          username: username,
          badge: badge,
          iconMenu: !(0, _isEmpty2.default)(iconMenu)
        }),
        _react2.default.createElement(
          'section',
          { style: _styles2.default.audioContainer },
          this.renderButton(),
          _react2.default.createElement(
            'div',
            { style: _styles2.default.playerContainer },
            _react2.default.createElement(
              'section',
              { style: _styles2.default.progressContainer },
              _react2.default.createElement('div', { style: _getStyles2.default.bar(color, myMessage, audio.progress) })
            ),
            _react2.default.createElement(
              'span',
              { style: _styles2.default.time },
              audio.time
            )
          )
        ),
        _react2.default.createElement(_messageTime2.default, {
          myMessage: myMessage,
          type: type,
          style: messageTimeStyle,
          createdAt: createdAt,
          fontSize: fontSize
        }),
        iconMenu ? _react2.default.createElement(
          'div',
          { style: _styles2.default.iconMenu },
          iconMenu
        ) : null
      );
    }
  }]);

  return AudioMessage;
}(_react.Component);

AudioMessage.propTypes = propTypes;
AudioMessage.defaultProps = defaultProps;

exports.default = AudioMessage;
module.exports = exports.default;